import axios from "@/libs/request";

// 悬浮窗提醒接口
export const remindApi = (params) => axios.request({ url: "/game/sdk-float/remind", params, unHint: true, method: 'get'});

// 悬浮窗首页接口
export const homeApi = (params) => axios.request({ url: "/game/sdk-float/home", params, unHint: true, method: 'get'});

// SDK悬浮窗攻略、菜单栏下的首页接口，获取子菜单列表及第一个菜单下的文章列表
export const raidersApi = (params) => axios.request({ url: "/game/sdk-float/menu/home", params, unHint: true, method: 'get'});

// 获取子菜单下的文章列表接口
export const raidersDetailApi = (params) => axios.request({ url: "/game/sdk-float/menu/detail", params, unHint: true, method: 'get'});

// 获取文章接口
export const articleApi = (params) => axios.request({ url: "/game/sdk-float/article", params, unHint: true, method: 'get'});

// 福利-礼包接口
export const giftApi = (data) => axios.request({ url: "/game/sdk-float/benefit/gift/v2", data, unHint: true, method: 'post'});

// 福利-礼包领取接口
export const giftReceiveApi = (data) => axios.request({ url: "/game/sdk-float/benefit/auto-gift-receive", data, method: 'post'});

// 福利-代金券接口
export const voucherApi = (data) => axios.request({ url: "/voucher/list", data, unHint: true });

// 获取盒子(个人中心)广告位和 banner 接口
 export const getBoxBanner = (data) => axios.request({ url: "/game/sdk-float/user/ad", data, unHint: true });

 // 盒子(个人中心)广告位和 banner 点击校验接口
 export const boxBannerValid = (data) => axios.request({ url: "/game/sdk-float/user/ad/valid", data });


 // 云挂机商品接口
 export const cloudProductApi = (data) => axios.request({ url: "/cloud-hang-up/product", data });
// 云挂机当前用户设备列表接口
export const cloudDeviceApi = (data) => axios.request({ url: "/cloud-hang-up/device", data });
// 修改云挂机设备名
export const cloudDeviceNameUpdate = (data) => axios.request({ url: "/cloud-hang-up/device/update", data });
// 云挂机游戏包更新接口
export const getCloudApkDownloadUrl = (data) => axios.request({ url: "/cloud-hang-up/update-url", data });

// 云挂机反馈选项接口
export const feedbackType = () => axios.request({ url: "/cloud-hang-up/feedback/type" });

// 云挂机反馈提交接口
export const feedbackSubmit = (data) => axios.request({ url: "/cloud-hang-up/feedback/commit", data });

// 获取云挂机F&Q
export const getCloudFAQ = () => axios.request({ url: "/cloud-hang-up/faq" });